import { TooltipV2 } from '@cimplico/components';
import { ExclamationTriangleIcon } from '@heroicons/react/24/solid';
import { FileStatusEnum } from '../../types/file-record';

function FileStatusIcon({ status }: { status: FileStatusEnum }): JSX.Element {
    if (status === FileStatusEnum.CHECKED_OUT) {
        return (
            <div>
                <TooltipV2 message="Checked Out" position="left">
                    <ExclamationTriangleIcon className="h-5 w-5 text-red-500 dark:text-red-500" />
                </TooltipV2>
            </div>
        );
    }
    return <></>;
}
export default FileStatusIcon;
